<template>
  <!-- Login Component -->
  <div>
    <div class="page-header">
      <v-layout row align-center>
        <v-icon x-large>mdi-lock-reset</v-icon>
        <h1 class="page-title">Reset Password</h1>
      </v-layout>
    </div>
    <v-form v-model="valid">
      <v-row>
        <v-col cols="12" lg="12" md="12" sm="12">
          <v-text-field
            required
            label="Email"
            prepend-icon="mdi-email"
            v-model="email"
            :rules="emailRules"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-spacer></v-spacer>
        <v-btn outlined :disabled="!valid" @click="onResetPassword"
          >Reset Password</v-btn
        >
      </v-row>
      <br />
      <v-row>
        <v-spacer></v-spacer>
        <v-btn outlined color="accent" @click="onRegister">Register</v-btn>
        <v-btn outlined color="accent" @click="onLogin">Login</v-btn>
      </v-row>
    </v-form>
    <div>
      <statusalert ref="alert" @closed="onStatusAlertClosed"></statusalert>
    </div>
  </div>
</template>

<script>
import store from '@/store/index.js'
import router from '@/router/index.js'
import AccountService from '@/services/api/AccountService.js'
import statusalert from '../../components/StatusAlert'

export default {
  name: 'Login',
  components: {
    statusalert
  },
  store: store,
  router: router,
  data: () => ({
    email: '',
    emailRules: [v => !!v || 'Email is required'],
    valid: false
  }),
  methods: {
    displayAlert() {
      this.$refs.alert.displayResult(this.result)
    },
    onLogin() {
      router.push('/Account/Login')
    },
    onRegister() {
      router.push('/Account/Register')
    },
    onResetPassword() {
      AccountService.reset(this.email)
        .then(result => {
          this.result = {
            isValid: true,
            statusCode: result.status,
            errors: ['Reset password started, check your email']
          }
        })
        .catch(error => {
          console.log(error)
          this.result = {
            isValid: false,
            statusCode: 404,
            errors: ['Reset Password failed']
          }
        })
        .finally(() => {
          store.commit('notLoading')
          this.displayAlert()
        })
    },
    onStatusAlertClosed() {}
  }
}
</script>
